import { createFileRoute } from '@tanstack/react-router'
import { DraftsPage } from '@/components/pages/DraftsPage'

export const Route = createFileRoute('/workspace/drafts')({
  component: DraftsPage,
})
